// extracted by mini-css-extract-plugin
export var layoutContainer = "_a2-0";
export var layoutContainerNoRounding = "_a2-6";
export var layoutContainerOpen = "_a2-5";
export var layoutContainerResizing = "_a2-1";
export var mainContent = "_a2-2";
export var resizeDivider = "_a2-3";
export var slidePanel = "_a2-4";